// @flow
import React from 'react';
import type { Categories } from 'store/modules/brands';
import BrandLikeButton from 'components/brand/BrandLikeButton';
import { fromNow } from 'lib/common';
import BrandActionButtons from '../BrandActionButtons';
import './BrandHead.scss';
import BrandMobileShare from '../BrandMobileShare/BrandMobileShare';

type Props = {
  id: string,
  title: string,
  categories: Categories,
  user: {
    username: string,
    id: string,
    thumbnail: ?string,
    short_bio: ?string,
  },
  likes: number,
  liked: boolean,
  ownBrand: boolean,
  onToggleLike: () => void,
  onAskRemove: () => void,
  date: string,
  logged: boolean,
  url: string,
  isPrivate: boolean,
  informCopy: () => void,
};

const BrandHead = ({
  id,
  title,
  date,
  categories,
  user,
  likes,
  liked,
  ownBrand,
  onToggleLike,
  onAskRemove,
  logged,
  isPrivate,
  url,
  informCopy,
}: Props) => {
  return (
    <div className="BrandHead">
      <h1>{title}</h1>
      <div className="date-and-likes">
        <div className="date">{fromNow(date)}</div>
        <div className="placeholder" />
        <BrandMobileShare
          url={url}
          title={title}
          username={user.username}
          informCopy={informCopy}
        />
        <BrandLikeButton onClick={onToggleLike} liked={liked} likes={likes} disabled={!logged} />
      </div>
      <div className="separator" />
      {ownBrand && <BrandActionButtons id={id} onAskRemove={onAskRemove} />}
    </div>
  );
};

BrandHead.Placeholder = () => (
  <div className="BrandHead placeholder">
    <div className="gray-block _title" />
    <div className="date-and-likes">
      <div className="date">
        <div className="gray-block _date" />
      </div>
      <div className="placeholder" />
    </div>
    <div className="separator" />
  </div>
);
export default BrandHead;



// WEBPACK FOOTER //
// ./src/components/brand/BrandHead/BrandHead.js